<template>
  <vx-card v-show="isCardActiveLocal" :style="{ 'background-color': question.status == 'correct' && quizType == 'graded' ? 'rgba(107, 255, 81, 0.3)' : question.status == 'answered' || quizType == 'survey' ? 'none' : 'rgba(255, 56, 56, 0.3)' }">
    <div class="vx-row">
      <div v-if="quizType == 'graded'" class="vx-col w-full">
        <p>{{ question.questionText }}</p>
          <table> 
            <tr>
              <th style="text-align: center;">A</th>
              <th style="text-align: center;">B</th>
            </tr>
            <tr class="ml-0" v-for="(pair, index) in question.userMatches" :key="index">
              <td style="text-align: center;">
                <p>{{ question.premises[index] }}</p>
              </td>
              <td style="text-align: center;">
                <p :style="{'color': setColor(index, question) }">{{ question.responses[pair.premiseIndex] }}</p>
              </td>
            </tr>
          </table>

          <div v-if="showCorrectAnswer">
            <p class="mt-3" style="font-weight: 700">Required Answer:</p>
            <table> 
              <tr>
                <th style="text-align: center;">A</th>
                <th style="text-align: center;">B</th>
              </tr>
              <tr class="ml-0" v-for="(pair, index) in question.matches" :key="index">
                <td style="text-align: center;">
                  <p>{{ question.premises[index] }}</p>
                </td>
                <td style="text-align: center;">
                  <p>{{ question.responses[pair.premiseIndex] }}</p>
                </td>
              </tr>
            </table>
          </div>
        <div class="mt-2 vx-row">
          <vs-spacer></vs-spacer>
          <div class="vx-col">
            <p><small>Max Attempts: {{ question.maxAttempts }}</small></p>
            <p><small>Used Attempts: {{ question.usedAttempts }}</small></p>
          </div>
        </div>
      </div>
      <div v-else class="vx-col w-full">
        <p>{{ question.questionText }}</p>
          <table> 
            <tr>
              <th style="text-align: center;">A</th>
              <th style="text-align: center;">B</th>
            </tr>
            <tr class="ml-0" v-for="(pair, index) in question.userMatches" :key="index">
              <td style="text-align: center;">
                <p>{{ question.premises[index] }}</p>
              </td>
              <td style="text-align: center;">
                <p>{{ question.responses[pair.premiseIndex] }}</p>
              </td>
            </tr>
          </table>
      </div>
    </div>
    <comment-view :isCardActive="commentView" :question="question" :quizType="quizType" :predefinedComments="predefinedComments" :viewOnly="viewOnly"/>
  </vx-card>
</template>

<script>
  import commentView from './iSpringCommentView.vue';
  export default {
    components: {
      commentView
    },
    props: {
      isCardActive: {
        type: Boolean,
        required: true
      },
      question: {
        type: Object,
        required: false
      },
      questionCardTitle: {
        type: String,
        required: false
      },
      predefinedComments: {
        type:Array,
        required: false
      },
      quizType: {
        type: String,
        required: false
      },
      viewOnly: {
        type: Boolean,
        required: false
      }
    },
    data() {
      return {
        commentView: true,
        showCorrectAnswer: false
      }
    },
    computed: {
      isCardActiveLocal: {
        get() {
          return this.isCardActive;
        },
        set(val) {
          if (!val) {
            this.$emit("closeCard");
            this.initValues();
          }
        }
      },
    },
    watch: {
      isCardActive: function(val) {
        if(val){
          var self = this;
          if(self.question){
            
          }else{
            self.initValues();
          }
        }
      },
      question: function(val) {
        if(val){
          this.commentView = true;
        }
      }
    },
    methods: {
      setColor(index, question) {
        if(question.userMatches[index].premiseIndex == question.userMatches[index].responseIndex){
          this.showCorrectAnswer = false;
          return '#00cc00';
        }
        else{
          this.showCorrectAnswer = true;
          return 'red';
        }
      },
      saveData() {
        this.initValues();
        this.$emit('saveData');
      },
      initValues() {
        
        this.errors.clear();
      },
      scrollToNavbar() {
        var scrollOptions = {
          easing: 'ease-in',
          offset: -500,
          force: true,
          cancelable: true,
          x: false,
          y: true
        }
        var cancelScroll = this.$scrollTo(document.getElementById("navbarGlobal"), 500, scrollOptions);
      },
      scrollToFooter() {
        var scrollOptions = {
          easing: 'ease-in',
          offset: -480,
          force: true,
          cancelable: true,
          x: false,
          y: true
        }
        var cancelScroll = this.$scrollTo(document.getElementById("footerGlobal"), 100, scrollOptions);
      },
    }
  }

</script>

<style lang="scss">

</style>
